import { render } from "./_AlunosPdf.vue?vue&type=template&id=3bfbcee9&scoped=true"
import script from "./_AlunosPdf.vue?vue&type=script&lang=ts"
export * from "./_AlunosPdf.vue?vue&type=script&lang=ts"

import "./_AlunosPdf.vue?vue&type=style&index=0&id=3bfbcee9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3bfbcee9"

export default script